import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import { buildBusinessDirectoryParams } from '@/lib/business-directory-params';
import type { BusinessDirectoryFacets, BusinessDirectoryFiltersState } from '@/types';

interface FacetsResponse {
  facets: BusinessDirectoryFacets;
}

const fetcher = (url: string) =>
  axiosInstance.get<FacetsResponse>(url).then((res) => res.data.facets);

export function useBusinessDirectoryFacets(
  communityId?: string,
  search = '',
  filters: BusinessDirectoryFiltersState = {}
) {
  const params = buildBusinessDirectoryParams(search, filters);
  const query = params.toString();
  const url = communityId
    ? `/api/communities/${communityId}/business/filters${query ? `?${query}` : ''}`
    : null;

  const { data, error, isLoading } = useSWR<BusinessDirectoryFacets>(url, fetcher, {
    keepPreviousData: true,
  });

  return {
    facets: data,
    isLoading,
    isError: error,
  };
}
